import _ from 'lodash'
import { Cale_getEventReport } from './Cale.getEventReport'
import type { Type_ICalendarEvent, Type_IProcessedCalendarEvent, Type_IReport } from '../Type/Type.hive'

/**
 * The server sends down the event.complete prop once the report has been synced
 * This function determines if an event has a local (unuploaded, complete) report, or an open report
 */
export function Cale_getEventCompletion(
    events: Type_ICalendarEvent[],
    reports: Type_IReport[],
    currentReportEventId: string | number
): Type_IProcessedCalendarEvent[] {
    return events.map((event) => {
        const report = Cale_getEventReport(event, reports)

        const hasOpenReport = currentReportEventId != null && currentReportEventId === event.id

        const hasLocalReport = report != null

        return {
            ...event,
            hasLocalReport,
            hasOpenReport,
        }
    })
}
